export default {
    USER_ID: "user_Z68Kd8H8DcAU1LRzfjcxj",
    TEMPLATE_ID: "template_6028u56"
    }
    